import { get, derived, writable } from "svelte/store";
import { addError, addLog, addSystemMsg } from "./LoggerStore";
import Path from "../scripts/Path";
import { Node } from "../scripts/FileTypes";
import { FileMgr } from "./FileMgr";
import { Broom } from "../procs/Broom";
import { randomId, setStorage } from "../scripts/utils";
import SettingsMgr, { loadSettings, saveSettings } from "./SettingsMgr";
import youtubeClips from "../scripts/Clips";
export const resetSaved = (forceReset = false) => {
    const _resetSaved = () => {
        addSystemMsg("Reset JamOS");
        localStorage.clear();
        FileMgr.getInstance().reset();
        ProcMgr.getInstance().killAll();
        SettingsMgr.getInstance().reset();
        ProcMgr.getInstance().testInit();
    };
    if (forceReset) {
        _resetSaved();
        return true;
    }
    ProcMgr.getInstance().openModal({
        title: "Reset & Restart  Bread",
        descs: [
            `This action will set this bread to the initial state and cannot be undone.`,
        ],
        buttons: ["Reset", "Cancel"],
        callbacks: [_resetSaved, () => { }],
    });
    return true;
};
//migrate save/load bread functions here to remove circular dependencies
export function saveBread(forceSave = false) {
    const _save = () => {
        const f = FileMgr.getInstance();
        const p = ProcMgr.getInstance();
        const files = f.stringify();
        const proc = p.stringify();
        const data = JSON.stringify({
            files: files,
            proc: proc,
        });
        setStorage("breadData", data);
        saveSettings();
        return true;
    };
    const _cancel = () => {
        // procmgr.modalResult = { result: "cancel" };
        addLog("Save bread canceled.");
        return false;
    };
    if (forceSave) {
        _save();
        return;
    }
    ProcMgr.getInstance().openModal({
        title: "Save Bread",
        descs: [`This action will overwrite save data and cannot be undone.`],
        buttons: ["Save", "Cancel"],
        callbacks: [_save, _cancel],
    });
    return true;
}
export function loadBread(forceLoad = false) {
    //   const data = getCookie("breadData");
    const data = localStorage.getItem("breadData");
    if (!data) {
        return false;
    }
    const _load = () => {
        const parsed = JSON.parse(data);
        const files = parsed.files;
        const proc = parsed.proc;
        const settings = parsed.settings;
        const f = FileMgr.getInstance();
        const p = ProcMgr.getInstance();
        const loudLoad = true;
        try {
            if (loudLoad) {
                //loud load
                f.reset();
                p.killAll();
                setTimeout(() => {
                    f.loadFromString(files);
                    p.loadFromString(proc);
                }, 1);
            }
            else {
                f.loadFromString(files);
                p.loadFromString(proc);
            }
            loadSettings();
        }
        catch (error) {
            addError("Something went wrong when loading bread. Reset everything. Error : " +
                error);
            p.killAll();
            f.reset();
            p.testInit();
            SettingsMgr.getInstance().reset();
            return false;
        }
        return true;
    };
    const _cancel = () => {
        // procmgr.modalResult = { result: "cancel" };
        addLog("Load bread canceled.");
        return false;
    };
    if (forceLoad) {
        return _load();
    }
    ProcMgr.getInstance().openModal({
        title: "Load Bread",
        descs: [`This action will overwrite unsaved changes.`],
        buttons: ["Load", "Cancel"],
        callbacks: [_load, _cancel],
    });
    return true;
}
const filemgr = FileMgr.getInstance();
const setmgr = SettingsMgr.getInstance();
class Process {
    constructor(props) {
        this.props = props;
        this.id = props.id;
        this._onMount();
    }
    setId(id) {
        this.id = id;
        return this;
    }
    get isWindow() {
        return false;
    }
    incIndex() {
        return this;
    }
    decIndex() {
        return this;
    }
    _onMount() {
        var _a, _b;
        (_b = (_a = this.props).onMount) === null || _b === void 0 ? void 0 : _b.call(_a, this.props.id);
    }
    stringify() {
        return JSON.stringify({
            type: "proc",
            version: 1,
            content: JSON.stringify(this.props),
        });
    }
}
export class WinProc extends Process {
    constructor(props) {
        super(Object.assign({}, props));
        this.props = props;
    }
    get isWindow() {
        return true;
    }
    incIndex() {
        this.props.zIndex++;
        return this;
    }
    decIndex() {
        this.props.zIndex--;
        if (this.props.zIndex < 0) {
            addError(`window z index system gone wrong. Win id : ${this.id} of ${this.props.node.path.path}`);
        }
        return this;
    }
    _onMount() {
        var _a, _b;
        // on window process mount
        (_b = (_a = this.props).onMount) === null || _b === void 0 ? void 0 : _b.call(_a, this.props.id);
    }
    stringify() {
        // this.update();
        const copiedProps = Object.assign({}, this.props);
        {
            // copy data into props
            const windata = ProcMgr.getInstance().winDataFetcher(this.props.id);
            if (!copiedProps.data) {
                copiedProps.data = {};
            }
            for (const key in windata) {
                copiedProps.data[key] = get(windata[key]());
            }
        }
        const retval = {
            type: "winproc",
            version: 1,
            content: JSON.stringify(copiedProps),
        };
        console.log(`Str: ${this.props.name} : ${JSON.stringify(copiedProps.data)}`);
        return JSON.stringify(retval);
    }
}
const plainOk = {
    title: "Okay to proceed?",
    descs: [],
    buttons: ["Okay", "Cancel"],
    callbacks: [
        () => {
            console.log("OKAY");
        },
        () => {
            console.log("Cancel");
        },
    ],
};
export default class ProcMgr {
    constructor() {
        //Modal
        this.isModal = writable(false);
        this._modalResult = writable({});
        this.modalStore = writable(Object.assign({}, plainOk));
        this.loading = writable(false);
        this.procStore = writable([]);
        this.winStore = derived(this.procStore, (procs) => procs.filter((proc) => proc.isWindow));
        //used in Windows.svelte
        this.winStoreOrdered = derived(this.procStore, (procs) => procs.filter((proc) => proc.isWindow).sort((l, r) => r.props.zIndex - l.props.zIndex));
        this.winData = [];
        this.setWinDataFecther = (procId, key, func) => {
            if (!this.procValue(procId)) {
                return;
            }
            const found = this.winData.find((item) => item.id === procId);
            if (found) {
                found.data[key] = func;
            }
            else {
                const data = { id: procId, data: {} };
                data.data[key] = func;
                this.winData.push(data);
            }
        };
        this.id = 1;
        this.init();
    }
    openModal(args) {
        this.modalStore.set(Object.assign({}, args));
        this.isModal.set(true);
    }
    openError(descs, title, buttons, callbacks) {
        const modalData = {
            title: title || "Error!",
            descs: descs || ["An error occured"],
            buttons: buttons || ["Okay"],
            callbacks: callbacks || [() => { }],
        };
        modalData.title = title || modalData.title;
        modalData.descs = descs || modalData.descs;
        modalData.buttons = buttons || modalData.buttons;
        modalData.callbacks = callbacks || modalData.callbacks;
        addError(`Modal error : [${modalData.title}] : ${[...modalData.descs]}`);
        this.openModal(modalData);
    }
    closeError() {
        this.closeModal();
    }
    closeModal() {
        this.isModal.set(false);
    }
    get modalResult() {
        return get(this._modalResult);
    }
    set modalResult(args) {
        this._modalResult.set(Object.assign({}, args));
    }
    get procCount() {
        return derived(this.procStore, (procs) => procs.length);
    }
    setLoading(val) {
        this.loading.set(val);
    }
    toggleLoading() {
        this.loading.set(!get(this.loading));
    }
    startLoading() {
        this.setLoading(true);
    }
    finishLoading() {
        this.setLoading(false);
    }
    loadFromString(obj) {
        const _parsed = JSON.parse(obj);
        const procs = _parsed["procs"];
        if (!procs) {
            return false;
        }
        addSystemMsg("Preparing to load from string...");
        this.killAll();
        const procList = procs.map((proc) => {
            const params = JSON.parse(proc);
            const type = params["type"];
            const version = params["version"];
            const content = params["content"];
            if (!type || !version) {
                return;
            }
            if ("1" === `${version}`) {
                const parsed = JSON.parse(content);
                if (type === "proc") {
                    const props = {
                        id: parsed.id,
                    };
                    if (parsed["data"])
                        props["data"] = parsed["data"];
                    if (parsed["name"])
                        props["name"] = parsed["name"];
                    if (parsed["node"])
                        props["node"] = parsed["node"];
                    return new Process(props);
                }
                if (type === "winproc") {
                    const props = {
                        id: parsed.id,
                        comp: parsed.comp,
                        zIndex: parsed.zIndex,
                    };
                    if (parsed["data"])
                        props["data"] = parsed["data"];
                    if (parsed["name"])
                        props["name"] = parsed["name"];
                    if (parsed["node"])
                        props["node"] = parsed["node"];
                    return new WinProc(props);
                }
            }
        });
        this.procStore.set(procList);
        // console.log(
        //   "onload data : " + get(this.procStore).map((proc) => proc.props.data)
        // );
        let largestId = 0;
        get(this.procStore).forEach((proc) => {
            if (parseInt(proc.id) > largestId) {
                largestId = parseInt(proc.id);
            }
        });
        this.id = largestId + 1;
        addSystemMsg("Load proc complete");
        //load theme
        const themeName = _parsed["theme"];
        setmgr.setTheme(themeName);
    }
    stringify() {
        return JSON.stringify({
            procs: get(this.procStore).map((proc) => proc.stringify()),
            theme: get(setmgr.theme).name,
        });
    }
    // from ProcMgr => WinProc
    winDataFetcher(procId) {
        var _a;
        return (_a = this.winData.find((item) => item.id === procId)) === null || _a === void 0 ? void 0 : _a.data;
    }
    init() { }
    static getInstance() {
        if (!ProcMgr.instance) {
            ProcMgr.instance = new ProcMgr();
        }
        return ProcMgr.instance;
    }
    procValue(procId) {
        return get(this.procStore).find((proc) => proc.id === procId);
    }
    killAll(exceptIds = []) {
        const ids = get(this.procStore)
            .map((proc) => proc.id)
            .filter((proc) => !exceptIds.includes(proc));
        ids.forEach((id) => this.kill(id));
        addSystemMsg("Kill all process");
    }
    kill(procId) {
        const val = this.procValue(procId);
        if (!val) {
            addError(`Invalid request : kill process ${procId}. Process does not exist.`);
            return;
        }
        const procName = val.props.name || "";
        this.procStore.update((procs) => procs.filter((proc) => proc.id !== procId));
        if (val.isWindow) {
            const winVal = val;
            const axis = winVal.props.zIndex;
            this.procStore.update((procs) => procs.map((proc) => {
                // if window and is more back, decrease index;
                if (proc.isWindow && proc.props.zIndex > axis) {
                    proc.decIndex();
                }
                return proc;
            }));
        }
        addLog(`${val.isWindow ? "Window process" : "Process"} ${procName} (Id : ${procId}) killed`);
        return;
    }
    getNewId() {
        // return `<${ProcMgr._uniqueId}>` + `[${this.id++}]`;
        // return randomId();
        return "" + this.id++;
    }
    _prepareNewWindow() {
        this.procStore.update((procs) => procs.map((proc) => proc.incIndex()));
    }
    exeFile(path, args) {
        const f = filemgr.findFile(path) || filemgr.findDirValue(path);
        if (!f) {
            return;
        }
        this.exeCmd(f.node.exeCmd, Object.assign(Object.assign(Object.assign({}, f.node.args), args), { node: f.node }));
    }
    exeCmd(cmds, args) {
        const _cmds = cmds.split(" ").filter((cmd) => cmd !== "" && cmd !== " ");
        const cmdCount = _cmds.length;
        if (cmdCount === 0) {
            return;
        }
        const cmd = _cmds.at(0);
        if (cmdCount === 1) {
            this.add(_cmds.at(0), args);
            return;
        }
        //parse commadnds that take path as the rest of the arguments
        switch (cmd) {
            case "finder":
            case "notepad":
            case "markdown":
            case "browser":
            case "viewer":
                const path = _cmds.slice(1).join(" ");
                this.add(cmd, Object.assign({ path: path }, args));
                break;
            default:
                break;
        }
    }
    add(proc, args) {
        var _a, _b;
        if (!ProcMgr.commands.includes(proc)) {
            addError(`No command : ${proc}`);
            return;
        }
        if (ProcMgr.winCmds.includes(proc)) {
            this._prepareNewWindow();
        }
        const _id = this.getNewId();
        const props = {
            id: _id,
            comp: proc,
            zIndex: 0,
        };
        for (const key in args) {
            props[key] = args[key];
            addLog(`Add process. ${proc} props {${key} : ${args[key]}}`);
        }
        const forceOption = props["force"] ? true : false;
        switch (proc) {
            case "viewer":
            case "notepad":
                if (!(args === null || args === void 0 ? void 0 : args.path)) {
                    this.openError([`No path provided for  : ${proc}`]);
                    break;
                }
                const ftype = (_b = (_a = filemgr.findFile(new Path(args.path))) === null || _a === void 0 ? void 0 : _a.node) === null || _b === void 0 ? void 0 : _b.type;
                if (proc === 'viewer') {
                    if (ftype !== 'image') {
                        this.openError([`Image viewer could not open file : ${args.path}`]);
                        break;
                    }
                }
                if (proc === 'notepad') {
                    if (ftype !== 'text') {
                        this.openError([`Notepad could not open file : ${args.path}`]);
                        break;
                    }
                }
                this.procStore.update((procs) => {
                    if (args && args.path) {
                        props.data = {};
                        props.data.path = args.path;
                    }
                    const win = new WinProc(props);
                    return [...procs, win];
                });
                break;
            case "broom":
                Broom(this);
                break;
            case "terminal":
            case "logger":
            case "markdown":
            case "confirm":
            case "wire":
            case "atelier":
            case "hub":
            case "postman":
            case "bakery":
            case "about":
            case "settings":
            case "styler":
            case "jamchinko":
                this.procStore.update((procs) => {
                    const win = new WinProc(props);
                    return [...procs, win];
                });
                break;
            case "savebread":
                saveBread(forceOption);
                addLog("Save bread");
                break;
            case "loadbread":
                if (loadBread(forceOption)) {
                    addLog("Load bread");
                }
                else {
                    this.testInit();
                    addError("Load bread failed. Init with testInit");
                }
                break;
            case "resetbread":
                if (resetSaved(forceOption)) {
                    addLog("Reset bread");
                }
                else {
                    addError("Reset bread failed");
                }
                break;
            case "finder":
                //verify path first
                const node = filemgr.findDirValue(new Path(args.path));
                if (!node) {
                    addError(`Finder : Path to directory is not correct. Path : ${args.path}`);
                    return;
                }
                this.procStore.update((procs) => {
                    props.data = {};
                    props.data.path = args.path;
                    const win = new WinProc(props);
                    return [...procs, win];
                });
                break;
            case "browser":
                this.procStore.update((procs) => {
                    if (args && args.path && args.path.length) {
                        props.data = {};
                        props.data.path = args.path;
                    }
                    const win = new WinProc(props);
                    return [...procs, win];
                });
                break;
            default:
                break;
        }
    }
    //엄밀히 따지면 프로세스의 z-index는 별도의 어레이에 매핑되어 관리되는 것이 맞아보인다.
    setActiveWindow(props) {
        {
            // const winNameIndex = derived(this.winStore, procs=>procs.map(proc=>`${proc.props.name} : ${proc.props.zIndex}`));
            // console.log(get(winNameIndex));
        }
        const axis = props.zIndex;
        if (axis === 0) {
            return;
        }
        this.procStore.update((procs) => procs.map((proc) => {
            if (!proc.isWindow) {
                return proc;
            }
            const inStore = proc.props;
            if (inStore.zIndex > axis) {
                return proc;
            }
            //if more front
            if (inStore.zIndex < axis) {
                proc.incIndex();
                return proc;
            }
            //if self
            if (proc.props.id === props.id) {
                inStore.zIndex = 0;
                return proc;
            }
            return proc;
        }));
    }
    initPortfolio() {
        const _ = (name, path) => {
            return {
                node: new Node(new Path(`~/Portfolio/${name}`), "browser")
                    .setCmd(`browser ${path}`, { youtube: true })
                    .setIconPath("/imgs/jamos.png"),
                data: {},
            };
        };
        filemgr.addFile(_("1. Intro", youtubeClips()[0]));
        filemgr.addFile({
            node: new Node(new Path("~/Portfolio/Career Description"), "browser")
                .setCmd("browser https://v1.embednotion.com/embed/9091c7d511f941b387d3064690d4d2dd")
                .setIconPath("/imgs/career.svg"),
            // .setIconPath("/imgs/jamos.png"),
        });
        //structure image
        const names = [
            "1. OS Structure",
            "2. View Hierarchy",
            "3. Windows",
            "4. Brainstorming1",
            "5. Brainstorming2",
        ];
        for (let i = 1; i <= 5; ++i) {
            const name = names[i - 1];
            filemgr.addFile({
                node: new Node(new Path(`~/Portfolio/Structure/${name}.jpg`), "image")
                    .setCmd(`viewer ~/Portfolio/Structure/${name}.jpg`, {
                    src: `/imgs/docs/${i}.jpg`,
                })
                    .setIconPath(`/imgs/docs/${i}.jpg`),
                data: { src: `/imgs/docs/${i}.jpg` },
            });
        }
    }
    testInit() {
        // initFile();
        filemgr.reset();
        setmgr.reset();
        initMinimum();
        this.initPortfolio();
        // procmgr.add("finder", { path: "~/" });
        // procmgr.add("logger");
        // console.log("Procs : ", get(procmgr.procStore).at(0).isWindow);
        // procmgr.add("browser", { path: "https://www.goldenmeju.com" });
        // procmgr.add("confirm");
        // procmgr.add("atelier");
        // procmgr.add("hub");
        // procmgr.add("postman");
        // procmgr.add("bakery");
        // procmgr.add("about");
        // procmgr.add("pyscript");
        // this.add("jamchinko");
        // this.add("atelier");
        this.add("terminal", {
            terminal: { welcome: true },
            data: {
                rect: { top: "7%", left: "7%", width: "53%", height: "86%" },
            },
        });
        if (false) {
            // const res = localStorage.getItem("isFirst");
            // if (res !== "no") {
            //   setTimeout(() => {
            //     procmgr.add("terminal", {
            //       // maximizeOnMount: true,
            //       terminal: { welcome: true },
            //     });
            //   }, 500);
            //   localStorage.setItem("isFirst", "no");
            // }
        }
        // procmgr.exeFile(new Path("~/sample directory/file.txt"));
    }
}
ProcMgr._uniqueId = randomId(256);
//procs here are not windowed
ProcMgr.procCmds = ["broom", "savebread", "loadbread", "resetbread"];
ProcMgr.winCmds = [
    "notepad",
    "markdown",
    "viewer",
    "editor",
    "browser",
    "terminal",
    "logger",
    "finder",
    "boot-loader",
    "confirm",
    "wire",
    "atelier",
    "hub",
    "postman",
    "bakery",
    "about",
    "settings",
    "styler",
];
ProcMgr.commands = [...ProcMgr.winCmds, ...ProcMgr.procCmds];
const initMinimum = () => {
    const _ = (name, type) => {
        return {
            node: new Node(new Path(`~/${name}`), type),
            data: {},
        };
    };
    filemgr.addFile(_("Terminal", "terminal"));
    // filemgr.addFile(_("Postman", "postman"));
    // filemgr.addFile(_("Atelier", "atelier"));
    // filemgr.addFile(_("Broom", "broom"));
    filemgr.addFile(_("Bakery", "bakery"));
    filemgr.addFile(_("Styler", "styler"));
    // filemgr.addFile(_("Save Bread", "savebread"));
    // filemgr.addFile(_("Load Bread", "loadbread"));
    // filemgr.addFile(_("Reset Bread", "resetbread"));
    // filemgr.addFile(_("About", "about"));
    filemgr.addFile(_("Settings", "settings"));
    if (true) {
        filemgr.addFile({
            node: new Node(new Path("~/Favorites/GoldenMeju"), "browser")
                .setCmd("browser https://www.goldenmeju.com")
                .setIconPath("/imgs/meju.png"),
        });
        filemgr.addFile({
            node: new Node(new Path("~/Favorites/JamOS"), "browser")
                .setCmd("browser https://drawing-paper.netlify.app")
                .setIconPath("/imgs/jamos.png"),
        });
        filemgr.addFile({
            node: new Node(new Path("~/Favorites/Lorem Ipsum.txt"), "text"),
            data: {
                text: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec auctor libero quis elit venenatis varius eu blandit nisi. Proin dictum vehicula felis. In convallis, risus nec fringilla pellentesque, justo nulla interdum augue, sit amet posuere tortor elit sit amet lorem. Curabitur vehicula fermentum metus id tempus. Nam congue orci et nisi blandit posuere. Curabitur ultricies commodo accumsan. Ut iaculis nec enim pulvinar posuere. Donec auctor rhoncus quam, eget fermentum turpis lobortis id.

Praesent vel felis nec arcu fringilla dignissim non eget augue. Donec lorem mauris, aliquam vel placerat et, ultricies sit amet lectus. Morbi non aliquam justo. Suspendisse eget ante ipsum. Fusce nulla velit, egestas a rutrum nec, tincidunt vitae magna. Nunc tempor nunc quis nisl dapibus lacinia. Aenean convallis efficitur erat, quis elementum neque pellentesque ac. Suspendisse a nibh id dui tempus elementum. Sed consequat neque gravida tincidunt varius.

Vestibulum tempus tempus sem, a rhoncus nibh sollicitudin at. Aenean ultrices lectus id libero mattis vulputate. Morbi a neque non enim volutpat vestibulum et vel dolor. Donec cursus aliquam elit eget tincidunt. Phasellus rhoncus ullamcorper eros, sed fringilla velit scelerisque vitae. Sed ut orci maximus, condimentum felis tincidunt, pulvinar nulla. Mauris convallis nunc magna, a lobortis dui auctor in. Pellentesque pretium massa sed lacus mattis tempus. Duis sit amet semper neque. Phasellus placerat vitae elit quis pharetra. Nam nisl ante, dictum at vestibulum vel, tempor quis turpis. Pellentesque hendrerit laoreet ipsum, et consectetur elit volutpat quis.

Aenean pretium nibh massa. Sed facilisis fermentum condimentum. Integer magna ante, dictum suscipit vulputate nec, venenatis a elit. Aenean eget nibh ex. Integer quis blandit tellus, eget tincidunt enim. In luctus tincidunt mollis. Cras urna massa, tempus at velit tincidunt, scelerisque porttitor justo. Suspendisse varius, quam sit amet imperdiet ullamcorper, risus mi viverra tortor, at pulvinar odio metus vitae sem. Quisque volutpat arcu vel libero congue euismod.

Mauris posuere enim et augue imperdiet, eu auctor neque mattis. Aliquam molestie nibh elementum, pretium orci in, feugiat mi. Nullam eu lacus sed erat bibendum varius. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Praesent condimentum consequat tellus nec laoreet. Nunc volutpat nisl iaculis nisi dapibus placerat. Donec aliquet ut tellus eu fringilla.`,
            },
        });
    }
    if (0) {
        //hub
        filemgr.addFile({
            node: new Node(new Path("~/JamHub"), "hub").setIconPath("/imgs/jamos256.png"),
            data: {},
        });
    }
};
export class OS {
}
OS.file = FileMgr.getInstance();
OS.proc = ProcMgr.getInstance();
OS.settings = SettingsMgr.getInstance();
